import script from "./InformationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationTable.vue?vue&type=script&setup=true&lang=js"

import "./InformationTable.vue?vue&type=style&index=0&id=c0c47554&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c47554"]])

export default __exports__